import moment from "moment";

export const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Fecha',
        dataIndex: 'fecha',
        key: 'fecha',
        render:(date) => moment(date).format('DD/MM/YYYY')
      },
      {
        title: 'ID\u00A0Orden\u00A0Usuario',
        dataIndex: 'id_ordenUsuario',
        key: 'id_ordenUsuario',
      },
      {
        title: 'Ticket',
        dataIndex: 'ticket',
        key: 'ticket',
      },
      {
        title: 'Plataforma',
        dataIndex: 'plataforma',
        key: 'plataforma',
      },
      {
        title: 'ID\u00A0Motorista',
        dataIndex: 'id_motorista',
        key: 'id_motorista',
      },
      {
        title: 'Nombre\u00A0Motorista',
        dataIndex: 'nombre_motorista',
        key: 'nombre_motorista',
      },
      {
        title: 'Apellido\u00A0Motorista',
        dataIndex: 'apellido_motorista',
        key: 'apellido_motorista',
      },
      {
        title: 'ID\u00A0Cobertura',
        dataIndex: 'id_cobertura',
        key: 'id_cobertura',
      },
      {
        title: 'Zona\u00A0Cobertura',
        dataIndex: 'zona_cobertura',
        key: 'zona_cobertura',
      },
      {
        title: 'Delivery\u00A0Fee\u00A0Zona',
        dataIndex: 'delivery_fee_zona',
        key: 'delivery_fee_zona',
      },
      {
        title: 'Delivery\u00A0Fee',
        dataIndex: 'delivery_fee',
        key: 'delivery_fee',
      },
      {
        title: 'Total\u00A0Orden',
        dataIndex: 'total_orden',
        key: 'total_orden',
      },
      {
        title: 'Subtotal\u00A0Orden',
        dataIndex: 'subtotal_orden',
        key: 'subtotal_orden',
      },
      {
        title: 'Efectivo',
        dataIndex: 'efectivo',
        key: 'efectivo',
      },
      {
        title: 'Tarjeta',
        dataIndex: 'tarjeta',
        key: 'tarjeta',
      },
      {
        title: 'Crédito',
        dataIndex: 'credito',
        key: 'credito',
      },
      {
        title: 'Reintegrar',
        dataIndex: 'reintegrar',
        key: 'reintegrar',
      },
      {
        title: 'Cambio',
        dataIndex: 'cambio',
        key: 'cambio',
      },
      {
        title: 'ID\u00A0Comercio',
        dataIndex: 'id_comercio',
        key: 'id_comercio',
      },
      {
        title: 'Nombre\u00A0Comercio',
        dataIndex: 'nombre_comercio',
        key: 'nombre_comercio',
      },
      {
        title: 'Sucursal',
        dataIndex: 'sucursal',
        key: 'sucursal',
      },
      {
        title: 'Pago\u00A0Driver',
        dataIndex: 'pago_driver',
        key: 'pago_driver',
      },
      {
        title: 'Tipo\u00A0Pago',
        dataIndex: 'tipo_pago',
        key: 'tipo_pago',
      },
      {
        title: 'Cash\u00A0Out',
        dataIndex: 'cash_out',
        key: 'cash_out',
      },
      {
        title: 'Cash\u00A0In',
        dataIndex: 'cash_in',
        key: 'cash_in',
      },
      {
        title: 'Banco\u00A0Fee\u00A0Porcentaje',
        dataIndex: 'banco_fee_porcentaje',
        key: 'banco_fee_porcentaje',
      },
      {
        title: 'Banco\u00A0Fee',
        dataIndex: 'banco_fee',
        key: 'banco_fee',
      },
      {
        title: 'Banco\u00A0Fee\u00A0Extra',
        dataIndex: 'banco_fee_extra',
        key: 'banco_fee_extra',
      },
      {
        title: 'Banco\u00A0Fee\u00A0IVA',
        dataIndex: 'banco_fee_iva',
        key: 'banco_fee_iva',
      },
      {
        title: 'Adelanto\u00A0a\u00A0Cuenta',
        dataIndex: 'adelanto_a_cuenta',
        key: 'adelanto_a_cuenta',
      },
      {
        title: 'Utilidad',
        dataIndex: 'utilidad',
        key: 'utilidad',
      },
      {
        title: 'Orden\u00A0Activa',
        dataIndex: 'orden_activa',
        key: 'orden_activa',
      },
      {
        title: 'Moneda',
        dataIndex: 'moneda',
        key: 'moneda',
      },
      {
        title: 'Tasa\u00A0de\u00A0Conversión',
        dataIndex: 'tasa_conversion',
        key: 'tasa_conversion',
      },
      {
        title: 'Get\u00A0Fee\u00A0Porcentaje',
        dataIndex: 'get_fee_porcentaje',
        key: 'get_fee_porcentaje',
      },
      {
        title: 'Get\u00A0Fee',
        dataIndex: 'get_fee',
        key: 'get_fee',
      },
      {
        title: 'IVA',
        dataIndex: 'iva',
        key: 'iva',
      },
      {
        title: 'ID\u00A0Liquidación',
        dataIndex: 'id_liquidacion',
        key: 'id_liquidacion',
        render: (text) => text || '-',
      },
      {
        title: 'ID\u00A0Corte',
        dataIndex: 'id_corte',
        key: 'id_corte',
      },
      {
        title: 'ID\u00A0Corte\u00A0Motorista',
        dataIndex: 'id_corte_motorista',
        key: 'id_corte_motorista',
        render: (text) => text || '-',
      },
      {
        title: 'ID\u00A0Agente',
        dataIndex: 'id_agente',
        key: 'id_agente',
        render: (text) => text || '-',
      },
      {
        title: 'Motorista\u00A0Get',
        dataIndex: 'motorista_get',
        key: 'motorista_get',
      },
      {
        title: 'Porcentaje Envío',
        dataIndex: 'porcentaje_envio',
        key: 'porcentaje_envio',
      },
      {
        title: 'Ganancia\u00A0Envío',
        dataIndex: 'ganancia_envio',
        key: 'ganancia_envio',
      },
      {
        title: 'Driver\u00A0Retiro\u00A0Saldo',
        dataIndex: 'driver_retiro_saldo',
        key: 'driver_retiro_saldo',
      },
      {
        title: 'Tu\u00A0Nicaragua',
        dataIndex: 'tu_nicaragua',
        key: 'tu_nicaragua',
      },
      {
        title: 'Porcentaje\u00A0Incremento\u00A0Precio',
        dataIndex: 'porcentaje_incremento_precio',
        key: 'porcentaje_incremento_precio',
      },
      {
        title: 'Incremento\u00A0Precio',
        dataIndex: 'incremento_precio',
        key: 'incremento_precio',
      },
      {
        title: 'ID\u00A0Usuario\u00A0App',
        dataIndex: 'idusuario_app',
        key: 'idusuario_app',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Apellido',
        dataIndex: 'last_name',
        key: 'last_name',
      },
      {
        title: 'Dirección',
        dataIndex: 'direccion',
        key: 'direccion',
        render:(direccion) => direccion.substring(0,20) + '...'
      },
      {
        title: 'Tipo\u00A0Documento',
        dataIndex: 'tipo_documento',
        key: 'tipo_documento',
      },
      {
        title: 'Documento',
        dataIndex: 'documento',
        key: 'documento',
      },
      {
        title: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
        render:(descripcion) => descripcion.substring(0,20) + '...'
      },
      {
        title: 'Descripción\u00A0Extra',
        dataIndex: 'descripcion_extra',
        key: 'descripcion_extra',
      },
  ]
